import Link from "next/link"
import { useRouter } from "next/router"

import ThemeToggle from "./theme-toggle"

const pages = [
  { href: "/es-projektai", name: "ES projektai" },
  { href: "/about", name: "Apie" },
]

const Navbar = () => {
  const { pathname } = useRouter()

  return (
    <header className="mx-auto w-full max-w-2xl px-5 pt-6">
      <nav
        aria-label="Pagrindinis meniu"
        className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3"
      >
        <Link
          href="/"
          className="flex items-center gap-2 font-semibold text-black no-underline dark:text-white"
        >
          <span aria-hidden className="inline-block h-3 w-3 bg-mustard" />
          Pirmas kodas
        </Link>
        <ul className="flex items-center gap-5">
          {pages.map((page) => {
            const active = pathname.startsWith(page.href)
            return (
              <li key={page.href}>
                <Link
                  href={page.href}
                  aria-current={active ? "page" : undefined}
                  className={
                    active
                      ? "text-black decoration-mustard decoration-2 dark:text-white"
                      : "text-zinc-600 no-underline hover:text-black dark:text-zinc-400 dark:hover:text-white"
                  }
                >
                  {page.name}
                </Link>
              </li>
            )
          })}
          <li className="flex">
            <ThemeToggle />
          </li>
        </ul>
      </nav>
    </header>
  )
}

export default Navbar
